export const floorPlansSelector = state => state.whiteLabel.filter.get('floorPlans');
export const selectedFloorIndexSelector = state => state.whiteLabel.filter.get('selectedFloorIndex');
export const buildingHeroesSelector = state => state.whiteLabel.filter.get('buildingHeroes');
export const featuresSelector = state => state.whiteLabel.filter.get('features');
export const selectedFeaturesSelector = state => state.whiteLabel.filter.get('selectedFeatures');
